import React from 'react';
import { useUserProfile, TravelPartyType } from '../context/UserProfileContext';
import { UsersIcon, HeartIcon, Baby, Sparkles } from 'lucide-react';
export const TravelPartySelector = ({
  onClose
}: {
  onClose?: () => void;
}) => {
  const {
    travelParty,
    setTravelParty
  } = useUserProfile();
  const handleSelect = (party: TravelPartyType, e: React.MouseEvent) => {
    e.stopPropagation();
    setTravelParty(party);
    if (onClose) onClose();
  };
  const partyOptions: {
    type: TravelPartyType;
    label: string;
    icon: React.ReactNode;
    description: string;
  }[] = [{
    type: 'couple',
    label: 'Couples',
    icon: <HeartIcon className="w-5 h-5" data-id="element-223" />,
    description: 'Romantic getaways'
  }, {
    type: 'youngster',
    label: 'Youngsters',
    icon: <Sparkles className="w-5 h-5" data-id="element-224" />,
    description: 'Solo & friend groups'
  }, {
    type: 'family',
    label: 'Families',
    icon: <Baby className="w-5 h-5" data-id="element-225" />,
    description: 'Traveling with kids'
  }];
  return <div className="bg-white rounded-lg shadow-lg p-4" data-id="element-226">
      <h3 className="font-semibold mb-3" data-id="element-227">I'm traveling as:</h3>
      <div className="space-y-2" data-id="element-228">
        {partyOptions.map(option => <div key={option.type} className={`flex items-center gap-3 p-3 rounded-lg cursor-pointer transition ${travelParty === option.type ? 'bg-rose-50 border border-rose-200' : 'hover:bg-gray-50 border border-transparent'}`} onClick={e => handleSelect(option.type, e)} data-id="element-229">
            <div className={`p-2 rounded-full ${travelParty === option.type ? 'bg-rose-100 text-rose-500' : 'bg-gray-100 text-gray-500'}`} data-id="element-230">
              {option.icon}
            </div>
            <div data-id="element-231">
              <div className="font-medium" data-id="element-232">{option.label}</div>
              <div className="text-xs text-gray-500" data-id="element-233">{option.description}</div>
            </div>
          </div>)}
      </div>
    </div>;
};